




















































































































import { CameraImage } from "@/store/modules/CameraImage/interface";
import Utils from "@/utils/utils";
import Vue from "vue";

interface CssStyle {
  color?: string;
  backgroundColor?: string;
}

export default Vue.extend({
  name: "DeviceCardBoxLapi",
  props: {
    last_image: {
      type: Object,
      default: () => null
    },
    defineBatteryColor: Object,
    calculate_battery_level: Number,
    card_class: {
      type: String,
      default: ""
    },
    text_class: {
      type: String,
      default: ""
    }
  },
  components: {},
  data() {
    return {};
  },
  methods: {
    formattedDate(date: string | Date): string {
      return Utils.transformDateToYMDHMS(date);
    }
  },
  computed: {
    remplissageColor(): CssStyle {
      const actual_remplissage = (this.last_image as CameraImage)?.remplissage;
      switch (true) {
        case actual_remplissage >= 80 && actual_remplissage < 90:
          return {
            color: "var(--alyce-orange)"
          };
        case actual_remplissage >= 90:
          return {
            color: "var(--button-no-color)"
          };
        default:
          return {
            color: "var(--button-yes-color)"
          };
      }
    },
    display_day_time(): string {
      return `${this.last_image.icr_day_start} - ${this.last_image.icr_day_end}`;
    },
    display_night_time(): string {
      return `${this.last_image.icr_night_start} - ${this.last_image.icr_night_end}`;
    }
  },
  watch: {}
});
